import {GET_EVENTS_START} from "../../types";

export const events = (payload) => ({
  type: GET_EVENTS_START,
  payload,
});
